const stickyElementModule = () => import(/* webpackChunkName: 'utils/stickyElement' */'../../utils/js/stickyElement');
const participantsViewModule = () => import(/* webpackChunkName: 'components/search/participantsView' */'../searchForm/participants/participants');
const dayVisitorParticipantsViewModule = () => import(/* webpackChunkName: 'components/search/dayVisitorParticipantsView' */'../../pages/dayVisitor/searchEngine/facettes/_participants');
const durationViewModule = () => import(/* webpackChunkName: 'components/search/durationView' */'../searchForm/duration/duration');
const lastSearchesViewModule = () => import(/* webpackChunkName: 'components/search/lastSearchesView' */'../lastSearchList/lastSearchList');
const countrySiteViewModule = () => import(/* webpackChunkName: 'components/search/countrySiteView' */'../searchForm/countrysite/countrysite');
const flexPeriodViewModule = () => import(/* webpackChunkName: 'components/search/flexPeriod' */'../searchForm/flexPeriod/flexPeriod');
const startingPriceModule = () => import(/* webpackChunkName: 'components/startingPrice' */'../../components/startingPrice/startingPrice');
const virtualTourModule = () => import(/* webpackChunkName: 'components/virtualTour' */'../../components/virtualTour/virtualTour');

import { DatePickersView } from '../searchForm/dates/dates';
import { getUrlParameter } from '../../utils/js/getUrlParameter';
import { getSeason } from '../../utils/js/getSeason';
import SearchTogglerView from '../searchToggler/searchToggler';

export const SearchView = Backbone.View.extend({
  events: {
    'click .js-displaySearchFormList': 'displaySearchFormList',
    'click .js-submitSearch': 'submitSearch',
    'click .js-searchFormCloseLayer': 'closeLists',
    'click .js-searchForm-countryList .js-searchFormCloseLayer': 'closeListCountryClickHandler'
  },

  /**
   * Initialize search view
   * @param {Object} options
   */
  initialize(options) {
    const $body = $('body');
    this.isDayVisitor = typeof isDayVisitor !== 'undefined' && isDayVisitor;
    this.disableCalendarOpening = false;
    this.isHome = $body.hasClass('home');
    this.flexPeriodDisplayed = false;

    this.htmlMobileSearchEngineOpenClass = 'html-searchMobileEngineOpen';
    this.bodyMobileSearchEngineOpenClass = 'body-searchMobileEngineOpen';

    if ((typeof SEARCH_SCRIPTS !== 'undefined' && SEARCH_SCRIPTS.COLLECTION !== '') || this.isDayVisitor) {
      this.setElement(options.element);
      this.model = options.model;
      this.mainEngineModel = this.model.get('mainSearch');
      this.temporaryModel = this.model.get('temporarySearch');
      this.scrollPos = 0;
      this.abortSeeAll = false;
      this.hasFilters = $('#js-searchFilters').length > 0;
      this.hasResultsList = typeof isResultList !== 'undefined' && isResultList;
      this.hasCountryList = typeof FACETTE_COUNTRY_SCRIPTS !== 'undefined';
      this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
      this.$triggerSubmitSearchMobile = $('.js-triggerSubmitSearchMobile');
      this.clickToTriggerAfterDataUpdate = false;
      this.facetteOpened = false;
      this.unchanged = true;
      this.memoRenderData = null;
      this.hasMulticottage = this.mainEngineModel.getResume().accommodationNb > 1;

      this.$filterBlock = $('.js-searchFilters-filterContent');
      this.$filterBlockContent = this.$filterBlock.parent();
      this.$filterBlockContainer = this.$filterBlockContent.parent();
      this.$triggerSubmitOpenSearchMobile = $('.js-searchForm-openSearchMobile--submit');

      this.$triggerSubmitSearchMobile.on('click', e => {
        if (DEVICE.isMobile) {
          this.submitSearch(e);
        }
      });

      if ($body.hasClass('home')) {
        this.$triggerSubmitOpenSearchMobile.on('click', e => {
          if (DEVICE.isMobile) {
            const $target = $(e.currentTarget);
            const $stickyParent = $target.closest('.js-searchForm-openSearchMobile--sticky');
            if ($stickyParent.length) {
              e.preventDefault();
              /* If click occured during sticky, toggle open search popin instead of submit */
              if ($stickyParent.hasClass('stickySearch')) {
                if (!$body.hasClass(this.bodyMobileSearchEngineOpenClass)) {
                  const $toggleTrigger = $('.js-searchForm-container > .js-searchForm-toggler.api_toggle');
                  if ($toggleTrigger.length) {
                    e.stopPropagation(); // Prevent loader to display since we only toggle the popin
                    $toggleTrigger.first().trigger('click');
                  }
                }
                button.clearButtonLoader();
              } else {
                Tracking.dataLayerPush(JSON.parse($target.attr('data-tracking-submit')));
                this.submitSearch(e);
              }
            }
          }
        });
      }

      // Instanciation de l'action du formulaire, si nous sommes confrontés à une page sans résultat de recherche, qui pointe donc vers la search
      if (!this.hasResultsList) {
        this.$el.attr('action', SEARCH_SCRIPTS.URL_SEARCH);
      }

      if (this.hasCountryList) {
        countrySiteViewModule().then(({ CountrySiteView }) => {
          new CountrySiteView({'model': this.model, 'element': $('.searchForm-parkSelectContainer')});
        });
      }

      if (typeof isFacetteDate !== 'undefined') {
        this.datePickerOptions = options.datePickerOptions;
        this.datePickersView = new DatePickersView({
          model: this.model,
          datePickerOptions: this.datePickerOptions,
          element: this.$el
        });
      }

      this.initStickySearch();
      this.initDelayClick();

      if (typeof isFacetteMultiParticipants !== 'undefined' || this.isDayVisitor) {
        if (this.isDayVisitor) {
          dayVisitorParticipantsViewModule().then(({DayVisitorParticipantsView}) => {
            this.ParticipantsView = new DayVisitorParticipantsView({'model': this.model, 'element': this.$el});
          });
        } else {
          participantsViewModule().then(({ParticipantsView}) => {
            this.ParticipantsView = new ParticipantsView({'model': this.model, 'element': this.$el});
          });
        }
      }

      if (getUrlParameter('fromresa')) {
        if (!window.scrollY) this.initScrollToProduct();
      }

      this.initScrollToFilters();
      new SearchTogglerView({'model': this.temporaryModel, 'context': this});

      if (DEVICE.isMobile && !this.isDayVisitor) {
        lastSearchesViewModule().then(({LastSearchesView}) => {
          new LastSearchesView(this.mainEngineModel);
          dispatcher.trigger('search:displayLastSearches', '.js_lastSearchesList');
        });
      }

      if (typeof SEARCH_SCRIPTS.DURATION_CP !== 'undefined' && SEARCH_SCRIPTS.DURATION_CP !== '') {
        durationViewModule().then(({DurationView}) => {
          new DurationView(this);
        });
      }

      flexPeriodViewModule().then(({FlexPeriodView}) => {
        new FlexPeriodView(this);
      });

      virtualTourModule().then(({virtualTour}) => {
        virtualTour.init();
      });

      $('.js-openDateCartouche').on('click', e => {
        e.preventDefault();
        if (DEVICE.isMobile) {
          $('body').addClass('body-searchMobileEngineOpen body-searchMobileEngineOpened');
          $('#mainContainer').addClass('searchEngineOpened');
        }
        dispatcher.trigger('facette:dates:display', 'show', '.js-search-date_begin');
      });

      this.listenTo(dispatcher, 'searchView:scrollToSearchForm', this.scrollToSearchForm);
      this.listenTo(dispatcher, 'searchView:handleSearchEngineBackground', this.handleSearchEngineBackground);
      this.listenTo(dispatcher, 'searchView:render', this.render);
      this.listenTo(dispatcher, 'searchView:initStickySearch', this.initStickySearch);
      this.listenTo(dispatcher, 'searchView:closeLists', this.closeLists);
      this.listenTo(dispatcher, 'searchView:disallowFormAction', this.disallowFormAction);
      this.listenTo(dispatcher, 'searchView:memoChanging', this.memoChanging);
      this.listenTo(dispatcher, 'searchView:updateTemporaryModel', this.updateTemporaryModel);
      this.listenTo(dispatcher, 'searchView:submitSearch', this.submitSearch);
      this.listenTo(dispatcher, 'searchView:updateSearchEngineValues', this.updateSearchEngineValues);
      this.listenTo(dispatcher, 'searchView:closeSorts', this.closeSorts);

      this.stopListening(dispatcher, 'searchView:scrollToFilter');
      this.listenTo(dispatcher, 'searchView:scrollToFilter', this.scrollToFilter);
    }

    this.checkCookie();
  },

  /**
   * Close panel
   * @param {boolean} closeFilters
   * @param {boolean} [hideOverlay=true]
   */
  closeLists(closeFilters, hideOverlay = true) {
    closeFilters = typeof closeFilters !== 'boolean' ? true : closeFilters;

    if (hideOverlay) {
      this.searchBlured();
    }

    if (($('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length || ($('.js-selectKidAgeMulticottage-container:not(.isBaby):not(.isKid)').length) && $('.searchForm-capacityContainer').hasClass('searchForm-panel--bigger')) && $('.searchForm-capacity').hasClass('opened')) {
      // KIDS_AGES RELATED : close popin if click on cross
      dispatcher.trigger('kidsAges:setAgesError', true);
    } else {
      // Handling participants and capacity closure (if click on cross => event is transmitted, if click outside this is the facette name)
      const $body = $('body');
      const closeList = () => {
        $('.js-displaySearchFormList, .searchForm-block').removeClass('opened');
        $('.searchForm-parkSelectContainer').removeClass('opened');
        this.$el.find('.searchForm-block').show(0);
        $body.removeClass('body-displaySearchList js-delayAction');
        if (this.clickToTriggerAfterDataUpdate) {
          this.triggerClickDelayed();
        }
      };

      if (closeFilters) {
        const $searchFiltersListItem = $('.searchbar__filters__item');
        $body.removeClass('searchFiltersContainer-opened searchFiltersContainerLayer-opened searchFiltersContainerLayer-forceBG');
        if (!DEVICE.isMobile) {
          if ($searchFiltersListItem.hasClass('opened')) {
            this.$filterBlockContainer.stop().hide(0);
          }
          $('.api_autoClose').hide(0);
        }
        $searchFiltersListItem.removeClass('opened');
        dispatcher.trigger('facette:dates:display', 'hide');
      }

      this.closeSorts();

      closeList();
    }
  },

  // Close all sorting lists if they have the 'active' or 'toggle-active' classes
  closeSorts() {
    const $toggleButton = $('.js-SortButton');
    $toggleButton.removeClass('toggle-active');
    $(`${$toggleButton.attr('toggleSelector')}`).removeClass('active');
  },

  /**
   * Track click on close button for country panel
   */
  closeListCountryClickHandler() {
    Tracking.dataLayerPush({
      event: 'click',
      page_type: PAGE_SCRIPTS.page_template,
      area: 'overlay country park',
      cta_clicked: 'close'
    });
  },

  /*** HANDLING MAIN FORM CORRELATION ***/

  /**
   * Display a loader on main search form to wait for data update
   * with ajax call (bypass json filter) and trigger click after
   */
  initDelayClick() {
    if (!DEVICE.isMobile) {
      $('.js-delayClick').on('click', event => {
        event.preventDefault();
        event.stopPropagation();

        const $item = $(event.currentTarget);
        this.clickToTriggerAfterDataUpdate = $item.data('selector');
        this.closeLists();

        if (!this.unchanged) {
          loader.display('.searchForm');
        }
      });
    }
  },

  /**
   * Memorizing model change status to handle delayed click
   */
  memoChanging() {
    this.unchanged = false;
  },

  /**
   * Function to trigger after bypass json loaded
   */
  triggerClickDelayed() {
    if (!DEVICE.isMobile) {
      loader.remove('.searchForm');
      if (this.clickToTriggerAfterDataUpdate) {
        const item = $(this.clickToTriggerAfterDataUpdate);
        this.clickToTriggerAfterDataUpdate = false;
        item.trigger('click');
      }
    }
  },

  /**
   * Enable form submit after delay
   * @description Suppression de la classe du body qui active les liens pour déclencher les actions de click à retardement
   */
  allowFormAction() {
    if (!DEVICE.isMobile) {

      $('body').removeClass('js-delayAction');
      this.facetteOpened = false;
    }
  },

  /**
   * Disable form submit before ajax call
   * @description Ajout d'une classe au body qui active les liens pour déclencher les actions de click à retardement
   * @param {boolean} modelData
   */
  disallowFormAction(modelData = false) {
    if (!DEVICE.isMobile) {
      $('body').addClass('js-delayAction');
      if (modelData) {
        this.facetteOpened = modelData;
      }
    }
  },

  /**
   * Handling specific design on mobile, based on cascade stylesheet
   * @param {Function} callback
   */
  handleSearchEngineBackground(callback) {
    const $body = $('body');
    callback = typeof callback === 'function' ? callback : $.noop;

    if (DEVICE.isMobile) {
      const bodyMobileSearchEngineOpenedClass = 'body-searchMobileEngineOpened';

      // Hiding non-search element
      if (sessionStorage.getItem('basketDatas') === null && $('.basket-container').length === 0) {
        $body.toggleClass(this.bodyMobileSearchEngineOpenClass);

        if (!$body.hasClass(bodyMobileSearchEngineOpenedClass)) {
          $body.addClass(bodyMobileSearchEngineOpenedClass);
        } else {
          $body.removeClass(bodyMobileSearchEngineOpenedClass);
        }
        genericScrollTo.canIScroll(DEVICE.isMobile);
      }

      const pageWithoutScroll = typeof PRODUCT_SCRIPTS !== 'undefined' && PRODUCT_SCRIPTS.PRODUCT_TAB === `tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages` || GLOBAL_SCRIPTS.CONTROLLER === 'singleclick';

      if (this.hasResultsList && !pageWithoutScroll) {
        if (!$body.hasClass(this.bodyMobileSearchEngineOpenClass)) {
          $('.searchEngine-content').css('height', 'auto');
          const hasMulticottage = this.mainEngineModel.get('accommodationNb') > 1;
          const elementTarget = hasMulticottage && !!document.querySelector('.cartMultiProductBlock') ? '.cartMultiProductBlock' : '.resultList-Header';
          const margin = hasMulticottage && !!document.querySelector('.whatsNew-buttonSeeAll') ? document.querySelector('.whatsNew-buttonSeeAll').offsetHeight : document.querySelector('.js-searchForm-toggler').offsetHeight + 20;
          const scrollCoord = document.querySelector(elementTarget).getBoundingClientRect().y - margin;

          genericScrollTo.go(scrollCoord);
        } else {
          genericScrollTo.go(0, 0, 0);

          // Make filters and search engine scrollable
          const $searchFiltersList = $('.searchbar__filters');
          const $searchEngineContent = $('.searchEngine-content');

          if ($searchFiltersList.is(':visible') || $searchEngineContent.is(':visible')) {
            const windowHeight = window.innerHeight;
            const $contentElm = $searchEngineContent.is(':visible') ? $searchEngineContent : $searchFiltersList;
            const engineHeight = $contentElm.outerHeight();
            const buttonHeight = $('.searchForm-submitContainer').outerHeight();
            const headerHeight = $('.searchFilters-toggler').outerHeight();

            if (engineHeight > (windowHeight - buttonHeight - headerHeight)) {
              $contentElm.css({
                'overflow-y': 'scroll',
                height: (windowHeight - buttonHeight - headerHeight) + 'px'
              });
            }
          }
        }
      }

      if (!$body.hasClass(bodyMobileSearchEngineOpenedClass)) {
        callback();
      }

      if (!this.flexPeriodDisplayed) {
        dispatcher.trigger('facette:flexPeriod:getDatas');
        this.flexPeriodDisplayed = true;
      }
    } else {
      callback();
    }
  },

  /**
   * Specific display
   * @param {Event} event
   */
  displaySearchFormList(event) {
    event.preventDefault();

    if ($('.js-displaySearchFormList').hasClass('opened')) {
      this.searchFocused();
    } else {
      this.searchBlured();
    }

    this.unchanged = true;
    const $link = $(event.currentTarget);
    const modelData = $link.data('modeldata');
    const isOpen = $link.hasClass('opened');

    // On vérifie si tous les selects age sont remplis
    let isToOpen = true;

    if ($('.searchForm-capacity').hasClass('opened')) {
      isToOpen = !$('.js-selectKidAge-container, .js-selectKidAgeMulticottage-container').not('.isBaby, .isKid').length;
    }

    this.closeLists();

    // Ouverture du block ages si des selects ages doivent être remplis
    if (!isOpen && isToOpen) {
      if (modelData === 'capacity' && this.facetteOpened) {
        this.disallowFormAction(modelData);
      }
      // Handle checkbox preselection for country site
      if ($link.hasClass('js-domainSelector')) {
        dispatcher.trigger('facette:countrysite:domainPreselection');
      } else {
        $link.parent().toggleClass('opened');
      }

      // Handle display
      if (DEVICE.isMobile) {
        // Hiding non-search element
        $('body').toggleClass('body-displaySearchList');
        if ($link.hasClass('js-searchForm-dataCloser')) {//action on a mobile back button
          if (!$('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length && !$('.js-selectKidAgeMulticottage-container:not(.isBaby):not(.isKid)').length) {
            $link.removeClass('opened').closest('.searchForm').find('.searchForm-block').show(0);
          }
          this.closeLists();
        } else {
          // Handling display
          $link.addClass('opened');
        }
      } else {
        $link.next('.js-searchFormList').show(0);
        $link.addClass('opened');
        this.searchFocused();
        this.scrollToFilter($link, $link.next('.js-searchFormList'));

        dispatcher.trigger('kidsAges:calculateHeightBlock');
      }
    }
  },

  /**
   * Action when form is focused
   */
  searchFocused() {
    $('body').addClass('searchFocused');
  },

  /**
   * Action when form is blured
   */
  searchBlured() {
    if ($('.searchForm-panel').is(':visible')) {
      $('body').removeClass('searchFocused');
    }
  },

  /*** utilitaires ***/

  /**
   * Scroll jusqu'au formulaire de recherche s'il s'agit d'un formulaire de staticSearch
   */
  scrollToSearchForm() {
    const $searchMainContainer = $('#js-search-mainContainer');
    if ($('body').hasClass('hasResultsList') && $searchMainContainer.length) {
      genericScrollTo.go($searchMainContainer, 500, 20);
    }
  },

  /**
   * Réajuste le scroll quand le contenu du filtre n'est pas visible
   * @param {HTMLElement} scrollToElement
   * @param {HTMLElement} filterContainer
   */
  scrollToFilter(scrollToElement, filterContainer) {
    if (!DEVICE.isMobile) {
      let filterHeight = 0;
      const thisTopPosition = $(scrollToElement).offset().top;
      let windowPosition = $(window).scrollTop() + window.innerHeight - 40;

      if ($(scrollToElement).hasClass('js-domainSelector')) {
        filterHeight = $('.js-searchForm-countryList .searchForm-optionsList').height();
      } else {
        filterHeight = $(filterContainer).height();
      }

      if ((thisTopPosition + filterHeight) > windowPosition) {
        genericScrollTo.go($('#js-searchEngine'), 600, 75);
      }
    }
  },

  /**
   * Gestion soumission formulaire
   * @param {Event} event
   */
  submitSearch(event) {
    let focusOnSearch = true;

    if (typeof event === 'object') {
      event.preventDefault();
      if ($(event.currentTarget).hasClass('js-deleteBasket') || $(event.currentTarget).hasClass('js-basketMulticottage')) {
        focusOnSearch = false;
      }
    }

    this.model.get('filters').set({'lastModifiedFilter': null}); // reset lastFilter state to avoid filter popin to reopened

    //-- Do not submit if ages are not filled
    if (!$('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length && !$('.js-selectKidAgeMulticottage-container:not(.isBaby):not(.isKid)').length) {
      if (focusOnSearch) {
        if (!DEVICE.isMobile) {
          $('body').addClass('searchFocused');
          dispatcher.trigger('facette:dates:display', 'hide');
        }
      } else {
        $('body').addClass('basketOpened');
      }

      if (!this.isDayVisitor) {
        if (this.hasResultsList && DEVICE.isMobile && $('body').hasClass('body-searchMobileEngineOpened')) {
          //pour mobile, on ferme le moteur
          setTimeout(() => {
            if ($('body').hasClass('body-searchMobileEngineOpened')) {
              $('.js-searchForm-container .js-searchForm-toggler').click();
            }
          }, 300);
        }

        // Mise à jour du modèle à partir du modèle temporaire (NB : gestion des render via le modelWatch)
        this.mainEngineModel.set(this.temporaryModel.getResume(), {'silent': true});

        // Reset cookie dates when no best price on fp overview
        if (GLOBAL_SCRIPTS.CONTROLLER === 'product' && PRODUCT_SCRIPTS.PRODUCT_TAB === 'tab_cpe_domain' && $('.js-esiNoPrice').length) {
          dispatcher.trigger('search:updateMainSearchStore', 'dateend', null);
          dispatcher.trigger('search:updateMainSearchStore', 'date', null);
        }

        dispatcher.trigger('search:memorizingMainSearchCriteria');

        // Contrôle au cas où aucun pays ne soit ouvert par défaut
        if ($('.searchForm-country .searchForm-listHeader.opened').length === 0) {
          $('.searchForm-listContainer:not(.u-disabled) .searchForm-country .searchForm-listHeader').first().addClass('opened');
          $('.searchForm-listContainer:not(.u-disabled) .searchForm-country .searchForm-optionsList').first().show(0);
        }

        this.mainEngineModel.set({
          submitForm: true
        });

        //MAJ des variables SEARCH_SCRIPTS à la soumission
        const hasMulticottage = this.mainEngineModel.get('accommodationNb') > 1;
        const nbAdults = this.mainEngineModel.get('multiparticipants')[0].adults;
        const nbSeniors = this.mainEngineModel.get('multiparticipants')[0].seniors;
        const nbChildren = this.mainEngineModel.get('multiparticipants')[0].ages.length;
        const nbPets = this.mainEngineModel.get('multiparticipants')[0].pets;
        const ages = this.mainEngineModel.get('multiparticipants')[0].ages;
        const nbAdults2 = hasMulticottage ? this.mainEngineModel.get('multiparticipants')[1].adults : 0;
        const nbSeniors2 = hasMulticottage ? this.mainEngineModel.get('multiparticipants')[1].seniors : 0;
        const nbChildren2 = hasMulticottage ? this.mainEngineModel.get('multiparticipants')[1].ages.length : 0;
        const nbPets2 = hasMulticottage ? this.mainEngineModel.get('multiparticipants')[1].pets : 0;
        const ages2 = hasMulticottage ? this.mainEngineModel.get('multiparticipants')[1].ages : [];
        const arrivalDate = this.mainEngineModel.get('arrivalDate');
        const duration = this.mainEngineModel.get('duration');

        SEARCH_SCRIPTS.DATE_SELECTED = arrivalDate;
        SEARCH_SCRIPTS.DATE_END_SELECTED = this.mainEngineModel.get('departureDate');
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED = nbAdults;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED = nbSeniors;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED = ages;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED = nbPets;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].ADULTS_SELECTED = nbAdults2;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].SENIORS_SELECTED = nbSeniors2;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].AGES_SELECTED = ages2;
        SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].PETS_SELECTED = nbPets2;
        SEARCH_SCRIPTS.TOTALCOTTAGE = this.mainEngineModel.get('accommodationNb');
        SEARCH_SCRIPTS.TOTALPARTICIPANTS = nbAdults + nbSeniors + ages.length + (hasMulticottage ? nbAdults2 + nbSeniors2 + ages2.length : 0);
        SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED = nbAdults !== 2 || nbSeniors !== 0 || nbChildren !== 0 || nbPets !== 0 || nbAdults2 !== 0 || nbSeniors2 !== 0 || nbChildren2 > 0 || nbPets2 !== 0;

        if (SEARCH_SCRIPTS.TOTALCOTTAGE > 1 && GLOBAL_SCRIPTS.CONTROLLER === 'product') {
          $('.leadGen').hide();
          $('.js-cs').addClass('u-Hidden');
        } else {
          $('.js-cs').removeClass('u-Hidden');
        }

        if (GLOBAL_SCRIPTS.CONTROLLER === 'product') {
          const historyParams = {
            startDate: arrivalDate,
            duration: duration && arrivalDate === null ? duration : this.mainEngineModel.get('nights'),
            capacity: this.mainEngineModel.get('totalParticipants'),
            accommodationNb: this.mainEngineModel.get('accommodationNb'),
            hc: SEARCH_SCRIPTS.HOUSING_CODE
          };

          if (this.mainEngineModel.get('isFlexPeriod')) {
            historyParams.isFlexPeriod = true;
          }

          dispatcher.trigger('product:setProductHistoryCookie', historyParams);

          // Regenerate crossSell block according to new searchParams
          dispatcher.trigger('crosssell:refreshCrossSell', this.mainEngineModel);
        }

        // Scroll au niveau des filtres, si ceux-ci sont présents
        const searchTitleElement = !!document.querySelector('.resultList-Header') && !!document.querySelector('.resultList-Header').offsetParent ? '.resultList-Header' : false;

        if (!!searchTitleElement && focusOnSearch && !DEVICE.isMobile) {
          genericScrollTo.go(searchTitleElement, 500, 130);
        }

        // Handling stored search parameters
        // rule : update mainSearchUsed cookie at each search submit
        const mainSearchUsedNb = isNaN(parseInt(cookieManagement.getCookie('mainSearchUsed'))) ? 0 : parseInt(cookieManagement.getCookie('mainSearchUsed'));
        const main_search_used = mainSearchUsedNb + 1;

        cookieManagement.createCookie('mainSearchUsed', main_search_used, 30);

        Tracking.dataLayerPush({
          event: 'ABevent',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Search usage',
          gaLabel: 'Update search status',
          gaValue: 1,
          main_search_used: main_search_used
        });

        Tracking.dataLayerPush({
          event: 'clickEvent',
          clickCode: 'clickValidationForm',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'searchEngine',
          gaLabel: this.mainEngineModel.get('isFlexPeriod') || this.mainEngineModel.get('duration') ? 'Validation-by flex' : 'Validation',
          gaValue: 1
        });
      } else {
        // Handling tracking
        Tracking.dataLayerPush({
          event: 'clickEvent',
          clickCode: 'clickSubmitDayGuest',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'submit day visitor search',
          gaLabel: this.wordings.booking_submit + ' - ' + $('.js-dGuest-dayType-item.selected').data('daytype'),
          gaValue: 1
        });
        $('#js-searchEngine').submit();
      }

      this.closeLists(true, false);

      if (DEVICE.isDesktop && GLOBAL_SCRIPTS.CONTROLLER === 'product' && PRODUCT_SCRIPTS.PRODUCT_TAB === `tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`) {
        startingPriceModule().then(({StartingPrice}) => {
          new StartingPrice();
        });
      }
    }
  },

  /**
   * Rendu du formulaire
   * @param {string} modifiedModelKey - Clé correspondant au champ modifié en dernier
   * @param {boolean} datas - Données des filtres
   * @param {boolean} isTemp - Si les modifications sont liées au model temporaire ou au model normal
   */
  render(modifiedModelKey = '', datas = false, isTemp = false) {
    // this.memoRenderData : variable utilisée pour mémoriser les valeurs relatives au dernier rendu. Si les nouvelles datas sont identiques, il n'est pas besoin de faire tourner le render

    // Récupération des données
    const filtersData = datas ? datas : isTemp ? this.model.get('temporaryJSON_results').results.filter : this.model.get('JSON_results').results.filter;
    const changedAttributes = this.temporaryModel.changedAttributes();
    const isArrivalDateModified = typeof changedAttributes.arrivalDate !== 'undefined';
    const isDepartureDateModified = typeof changedAttributes.departureDate !== 'undefined' && changedAttributes.departureDate !== null;
    let closeArrivalDatePicker = false;
    let drawDepartureDatePicker = false;
    let drawArrivalDatePicker = false;
    let displayCalendarValidation = false;

    this.temporaryModel.set({'is_ESI_init': false}, {'silent': true});

    if (filtersData !== this.memoRenderData) {
      // Si la valeur des filtres a effectivement changé
      this.memoRenderData = filtersData;

      // Handling countrysite
      if (typeof FACETTE_COUNTRY_SCRIPTS !== 'undefined' && modifiedModelKey !== 'parks') {
        const facetteCountrySite = filtersData.countrysite;
        dispatcher.trigger('facette:countrysite:render', facetteCountrySite);
      }

      // Handling dates & duration
      const facetteDate = filtersData.date;
      const facetteDateEnd = filtersData.dateend;
      const duration = this.temporaryModel.get('duration');
      const arrivalDate = this.temporaryModel.get('arrivalDate');
      const departureDate = this.temporaryModel.get('departureDate');

      const arrDateList = facetteDate.values;
      dispatcher.trigger('facette:dates:updateAvailableDates', arrDateList, 'arrival');

      let prevDateList = _.filter(arrDateList, oDate => oDate.value < arrivalDate);
      let arrPrevDateList = Object.fromEntries(Object.entries(prevDateList).map(([key, oDate]) => [oDate.value, oDate]));

      let arrDateEndList = facetteDateEnd.values;
      // add previous arrivalDate to list
      arrDateEndList = Object.assign(arrPrevDateList, arrDateEndList); // adding prevDates to endDates
      dispatcher.trigger('facette:dates:updateAvailableDates', arrDateEndList, 'departure');

      /*** GESTION DES RENDER ***/
      // Gestion des affichages des calendriers

      /** FLEX_PERIOD **/
      const isFlexPeriod = this.temporaryModel.get('isFlexPeriod');
      if ((modifiedModelKey === 'arrivalDate' || isArrivalDateModified) && !isFlexPeriod) {
        if (DEVICE.isMobile && duration) {
          drawDepartureDatePicker = true;
          displayCalendarValidation = true;
        }
        if (arrivalDate === null) {
          if (DEVICE.isMobile) {
            drawArrivalDatePicker = true;
            drawDepartureDatePicker = false;
          } else {
            drawDepartureDatePicker = false;
          }
        } else {
          if (departureDate === null) {
            drawArrivalDatePicker = false;
            drawDepartureDatePicker = true;
          }
          closeArrivalDatePicker = true;
        }

        // Prevent displaying the calendar if triggered by flexDates change
        const flexDates = $('#js-flexDates');
        if (flexDates.length && flexDates.hasClass('loading') || ((duration || isDepartureDateModified) && !DEVICE.isMobile)) {
          drawDepartureDatePicker = duration !== 10 ? false : arrivalDate !== null;
        }
      }

      // Set back fix calendar to arrival when flex period selection
      if ((modifiedModelKey === 'isFlexPeriod' || modifiedModelKey === 'duration') && !$('body').hasClass('popinCottage')) {
        drawArrivalDatePicker = true;
        drawDepartureDatePicker = false;
      }

      // Disable Multicottage when flexPeriod
      $('#searchEngine-cottage .form-QuantityAdder').toggleClass('u-disabled', duration || isFlexPeriod);

      if (this.disableCalendarOpening === true) {
        drawArrivalDatePicker = false;
        drawDepartureDatePicker = false;
      }

      // Test pour exception 1 seule durée disponible sous mobile
      if (arrivalDate && departureDate && DEVICE.isMobile) {
        displayCalendarValidation = true;
      }

      // Handling participants
      if (typeof isFacetteMultiParticipants !== 'undefined' || this.isDayVisitor) {
        const facetteMultiParticipants = filtersData.multiparticipants;
        dispatcher.trigger('facette:participants:render', facetteMultiParticipants, true);
      }

      /*** Gestion des spécificités du calendrier ***/
      if (closeArrivalDatePicker) {
        this.datePickersView.arrivalDatepicker.pickerClose();
      }
      if (drawArrivalDatePicker) {
        const arrivalDatePickerAlreadyVisible = !($('.pika-single.arrival').hasClass('is-hidden'));
        this.datePickersView.arrivalDatepicker.draw();
        this.datePickersView.arrivalDatepicker.show();
        // Si le datepicker était déjà visible, on s'assure que la première date disponible soit affichée
        if (arrivalDatePickerAlreadyVisible && arrAvailableDates.length) {
          const firstDateDispo = arrAvailableDates[0];
          const dateConv = new Date(firstDateDispo);

          this.datePickersView.arrivalDatepicker.gotoDate(dateConv);
        }
      }
      if (drawDepartureDatePicker) {
        // Mise à jour de la date minimum d'affichage
        const minDateEnd = (arrivalDate !== '') ? new Date(arrivalDate) : new Date();
        this.datePickersView.departureDatepicker.gotoDate(minDateEnd);

        this.datePickersView.departureDatepicker.draw();
        this.datePickersView.departureDatepicker.show();
      } else {
        // Forcing departure datepicker hide
        if (!this.isDayVisitor) { // TODO : retirer quand separation moteur day visitor
          this.datePickersView.departureDatepicker.hide(0);
        }
      }

      // FLEX_PERIOD : calendar does not impact duration
      if (['duration', 'isFlexPeriod', 'departureDate'].includes(modifiedModelKey)) {
        dispatcher.trigger('duration:updateDurationValues', filtersData.durationcp.values);
        dispatcher.trigger('duration:render');
        dispatcher.trigger('duration:handleLoader', false);

        if (displayCalendarValidation) {
          dispatcher.trigger('facette:dates:displayCalendarValidation');
        }
      }

      if (modifiedModelKey === 'arrivalDate' || modifiedModelKey === 'isFlexPeriod') {
        dispatcher.trigger('duration:updateAvailability');
      }

      if (modifiedModelKey === 'arrivalDate' || modifiedModelKey === 'departureDate') {
        dispatcher.trigger('duration:handleLoader', false);
      }

      this.allowFormAction();
      this.triggerClickDelayed();

      /*** HANDLING FORCED DATE RANGE IN URL ***/
      if (modifiedModelKey === 'departureDate' && typeof isForcedRange !== 'undefined') {
        window.isForcedRange = false;
      }

      if (DEVICE.isMobile && !isTemp) {
        dispatcher.trigger('search:displayLastSearches', '.js_lastSearchesList');
      }

      // Remove button loaders
      setTimeout(() => {
        button.clearButtonLoader();
      }, 200);
    }

    // No calendar opening on render on first page load
    this.disableCalendarOpening = false;
  },

  /**
   * Init sticky search actions
   */
  initStickySearch() {
    const $body = $('body');
    if (GLOBAL_SCRIPTS.CONTROLLER !== 'product') {
      // Handling sticky animation of the searchForm for Mobile
      let selector = $body.hasClass('home') ? '.js-searchForm-openSearchMobile--sticky' : '.js-searchForm-toggler:not(.searchForm-toggler--home)';
      const $selector = $(selector);
      if ($selector.length) {
        stickyElementModule().then(({stickyElement}) => {
          stickyElement.init({
            selector: selector,
            fixedStart: $selector.offset().top,
            endStickySelector: '#js-footer',
            classSticky: 'stickySearch',
            deviceList: 'mobile',
            stickyCondition: () => {
              return typeof Connector !== 'undefined' && !Connector.isOpen() && !$('body').hasClass(this.bodyMobileSearchEngineOpenClass);
            },
            nameSpace: 'stickysearchMobile'
          });
        });
      }
    }

    if (SEARCH_SCRIPTS.PAGETYPE !== 'PRODUCT') {
      stickyElementModule().then(({stickyElement}) => {
        const stickyTarget = SEARCH_SCRIPTS.PAGETYPE !== 'ACCUEIL' ? '.searchbar' : DEVICE.isMobile ? '#cs-searchEngine-mobile' : '#cs-searchEngine';
        const comparatorRedesign = GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B' && ['Search', 'Destination', 'Region', 'Country'].includes(PAGE_SCRIPTS.page_template);
        const stickyPositionStart = parseInt($(stickyTarget).offset().top + $(stickyTarget).height());
        stickyElement.init({
          selector: 'body',
          fixedStart: comparatorRedesign ? $(stickyTarget).offset().top : stickyPositionStart,
          classSticky: 'stickySearchbar',
          nameSpace: 'searchbar',
          endStickySelector: '#js-footer'
        });
      });
    }
  },

  /**
   * Scroll to product when back from resa
   */
  initScrollToProduct() {
    if (SEARCH_SCRIPTS.GROUP === 'offer') {
      const resaSite = getUrlParameter('selected[site]');
      if (typeof resaSite !== 'undefined') {
        genericScrollTo.go($('#cartouche_' + resaSite), 600, 60);
        setTimeout(() => {
          $('#cartouche_' + resaSite + ' .js-displayHousings').click();
        }, 650);
      }
    } else {
      const paramsSelected = ['selected[housing]', 'option[multicottage][selected][1]', 'option[multicottage][selected][0]'];
      let idToScroll = '';
      for (const param of paramsSelected) {
        if (typeof getUrlParameter(param) !== 'undefined') {
          idToScroll = getUrlParameter(param);
          break;
        }
      }

      if (idToScroll !== '') {
        const $target = $('#accCart_' + idToScroll);
        if ($target.is(':hidden') && !!$('.js-seeMoreCottage').length) {
          const $parentTarget = $target.parent();
          $parentTarget.removeClass('u-Hidden');
          $parentTarget.prev('.seeMoreContainer').hide();
        }

        if ($target.length && typeof genericScrollTo !== 'undefined') {
          genericScrollTo.go($target, 600, 100);
        }
      }
    }
  },

  /**
   * Scroll to filters
   */
  initScrollToFilters() {
    $('.js-goToFilters').off('click.gotofilters').on('click.gotofilters', (e) => {
      const targetHef = e.currentTarget.dataset.href || null;

      // Get first filter target when no target or # defined
      if (!targetHef || targetHef === '#') {
        e.currentTarget.dataset.href = $('.js-filterOpener').first().data('href');
      }

      dispatcher.trigger('search:filters:showMobileFilters', e);
    });
  },

  /**
   * "Manual" temporary model update with ESI values
   * @param {Object} oDatas
   * @param {boolean} updateMainModel
   */
  updateTemporaryModel(oDatas, updateMainModel = false) {
    // Considering that for now, this function is used only in ESI CASE => disableCalendarOpening  is used to prevent calendar opening on page load
    this.disableCalendarOpening = true;
    if (updateMainModel) {
      this.mainEngineModel.set(oDatas);
    }

    oDatas.is_ESI_init = true;

    this.temporaryModel.set(oDatas);

    if (SEARCH_SCRIPTS.DISPLAY_DATE_OVERVIEW === '1' && $('body').hasClass('domain')) {
      dispatcher.trigger('facette:dates:updateDisabledStatusAndResetBtn'); // Handling disabled status & reset button
    }
  },

  /**
   * Force search engine values for esi pages
   */
  updateSearchEngineValues(ajaxParams, oParticipantsRules) {
    this.mainEngineModel = this.model.get('mainSearch');
    this.temporaryModel = this.model.get('temporarySearch');
    this.mainEngineModel.set({'participantsRules': oParticipantsRules}, {silent: true});
    this.temporaryModel.set({'participantsRules': oParticipantsRules}, {silent: true});
    this.temporaryModel.set(this.mainEngineModel.getResume(), {'silent': true});

    const hasMulticottage = ajaxParams.facet.MULTIPARTICIPANTS.length > 1 && Object.keys(ajaxParams.facet.MULTIPARTICIPANTS[1]).length,
      nbAdults = ajaxParams.facet.MULTIPARTICIPANTS[0].adult,
      nbSeniors = ajaxParams.facet.MULTIPARTICIPANTS[0].senior,
      nbChildren = typeof ajaxParams.facet.MULTIPARTICIPANTS[0].ages !== 'undefined' ? ajaxParams.facet.MULTIPARTICIPANTS[0].ages.length : 0,
      nbPets = ajaxParams.facet.MULTIPARTICIPANTS[0].pet,
      nbAdults2 = hasMulticottage ? ajaxParams.facet.MULTIPARTICIPANTS[1].adult : 0,
      nbSeniors2 = hasMulticottage ? ajaxParams.facet.MULTIPARTICIPANTS[1].senior : 0,
      nbChildren2 = hasMulticottage && typeof ajaxParams.facet.MULTIPARTICIPANTS[1].ages !== 'undefined' ? ajaxParams.facet.MULTIPARTICIPANTS[1].ages.length : 0,
      nbPets2 = hasMulticottage ? ajaxParams.facet.MULTIPARTICIPANTS[1].pet : 0,
      nbCottage = hasMulticottage ? 2 : 1;

    let arrivalDate,
      departureDate;

    $('#js-searchEngine-cottageNumber').val(nbCottage);
    $('#js-searchEngine-adultNumber').val(nbAdults);
    $('#js-searchEngine-seniorNumber').val(nbSeniors);
    $('#js-searchEngine-childrenNumber').val(nbChildren);
    $('#js-searchEngine-petsNumber').val(nbPets);
    $('#js-searchEngine-adultNumber_02').val(nbAdults2);
    $('#js-searchEngine-seniorNumber_02').val(nbSeniors2);
    $('#js-searchEngine-childrenNumber_02').val(nbChildren2);
    $('#js-searchEngine-petsNumber_02').val(nbPets2);

    $('#js-popinParticipants-adultNumber').val(nbAdults);
    $('#js-popinParticipants-seniorNumber').val(nbSeniors);
    $('#js-popinParticipants-childrenNumber').val(nbChildren);
    $('#js-popinParticipants-petsNumber').val(nbPets);

    if (nbCottage === 2) {
      $('.searchForm-quantityBlockCottage:nth-child(2) .form-QuantityContainer, .searchForm-quantityBlock--separator').removeClass('hidden');
      $('.searchForm-panel').addClass('searchForm-panel--bigger');
      $('#searchEngine-cottage').find('.form-QuantityRemover').removeClass('u-disabled');
      $('#searchEngine-cottage').find('.form-QuantityAdder').addClass('u-disabled');
      $('.js-goToFilters').addClass('isMulticottage');
    } else {
      $('.searchForm-quantityBlockCottage:nth-child(2) .form-QuantityContainer, .searchForm-quantityBlock--separator').addClass('hidden');
      $('.searchForm-panel').removeClass('searchForm-panel--bigger');
      $('#searchEngine-cottage').find('.form-QuantityRemover').addClass('u-disabled');
      $('#searchEngine-cottage').find('.form-QuantityAdder').removeClass('u-disabled');
      $('#js-searchFilters, .js-goToFilters').removeClass('u-Hidden isMulticottage');
    }

    dispatcher.trigger('kidsAges:initKidsAgesValues');
    dispatcher.trigger('facette:participants:updateFieldParticipants', true);

    const isFlexPeriod = typeof ajaxParams.option !== 'undefined' && ajaxParams.option.date_range && ajaxParams.option.flexholiday;

    if (isFlexPeriod) {
      dispatcher.trigger('facette:flexPeriod:getDatas');
      this.flexPeriodDisplayed = true;
    } else {
      if (typeof ajaxParams.facet.DATE !== 'undefined') {
        arrivalDate = ajaxParams.facet.DATE;
        if (arrivalDate !== '') {
          this.datePickersView.arrivalDatepicker.setDate(arrivalDate, true);
          this.datePickersView.$arrivalDate.removeClass('disabled').removeAttr('disabled');
          this.datePickersView.$arrivalDate.closest('.searchForm-inputContainer').removeClass('disabled');

          this.datePickersView.$arrivalDateInput.val(arrivalDate);
          dispatcher.trigger('facette:dates:updateDateFieldLabel', arrivalDate, '.js-search-arrivalDay');
          dispatcher.trigger('facette:dates:updateDisabledStatusAndResetBtn');
          dispatcher.trigger('facette:dates:updateDate', 'arrivalDate', arrivalDate, true);
        } else {
          this.datePickersView.arrivalDatepicker.setDate(null, true);
          ajaxParams.option.seasonCycle = getSeason(new Date().toISOString().split('T')[0]);
        }

        ajaxParams.option.seasonCycle = getSeason(arrivalDate);
      } else {
        this.datePickersView.arrivalDatepicker.setDate(null, true);
        dispatcher.trigger('facette:dates:updateDateFieldLabel', '', '.js-search-arrivalDay');
        ajaxParams.option.seasonCycle = getSeason(new Date().toISOString().split('T')[0]);
      }

      if (typeof ajaxParams.facet.DATEEND !== 'undefined') {
        departureDate = ajaxParams.facet.DATEEND;
        if (departureDate !== '') {
          this.datePickersView.departureDatepicker.setDate(new Date(departureDate), true);
          this.datePickersView.$departureDate.removeClass('disabled').removeAttr('disabled');
          this.datePickersView.$departureDate.closest('.searchForm-inputContainer').removeClass('disabled');
          this.datePickersView.$departureDateInput.val(departureDate);
          dispatcher.trigger('facette:dates:updateDateFieldLabel', departureDate, '.js-search-departureDay');
          dispatcher.trigger('facette:dates:updateDisabledStatusAndResetBtn');
          dispatcher.trigger('facette:dates:updateDate', 'departureDate', departureDate, true);
        } else {
          this.datePickersView.departureDatepicker.setDate(null, true);
          this.datePickersView.$departureDate.addClass('disabled').attr('disabled');
        }
      } else {
        this.datePickersView.departureDatepicker.setDate(null, true);
        this.datePickersView.$departureDate.addClass('disabled').attr('disabled');
        dispatcher.trigger('facette:dates:updateDateFieldLabel', '', '.js-search-departureDay');
        if (typeof ajaxParams.facet.DATE === 'undefined') $('.searchForm-globalDateContainer .js-pika-reset').removeClass('visible');
      }
    }

    if (typeof ajaxParams.facet.COUNTRYSITE !== 'undefined') {
      $(ajaxParams.facet.COUNTRYSITE).each((_index, item) => {
        $(`.js-country_${item.split('_')[1]} .js-checkbox-selectAll input, .js-countryCheckbox input[value="${item}"], .js-country_${item.split('_')[1]} .js-countryCheckbox input`).prop('checked', true).attr('checked', true);
      });

      dispatcher.trigger('facette:countrysite:parkValidation', false, true, true);
    }

    //MAJ toggler pour mobile
    if (DEVICE.isMobile) {
      if (!isFlexPeriod) dispatcher.trigger('search:toggler:updateDates', arrivalDate, departureDate);
      dispatcher.trigger('search:toggler:updateParticipants');
    }
  },

  checkCookie() {
    const cookie = JSON.parse(cookieManagement.getCookie('storedSearchParams'));
    if (cookie !== null) {
      if ('participantscp' in cookie) {
        cookie.multiparticipants = [cookie.participantscp];
        delete cookie.participantscp;
        cookieManagement.createCookie('storedSearchParams', JSON.stringify(cookie), 30);
      }
    }
  }
});